/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { GlobalError as ErrorBoundary } from 'src/components/error-boundary';

const SettingsVerticalAlignCenter = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  height: '100%',
  padding: token('space.800'),
  boxSizing: 'border-box',
});

export const GlobalError = () => (
  <SettingsVerticalAlignCenter>
    <ErrorBoundary />
  </SettingsVerticalAlignCenter>
);
